export default __webpack_public_path__ + "static/createrole-6ade0a3dca4626626ec4ed96736ec5dd.png";